// 图片预览组件
import Vue from 'vue'
import index from './index.vue'

let PreviewImageConstructor = Vue.extend(index)
let instance;
const PreviewImage = function (options = {}) {
    if (Object.prototype.toString.call(options).slice(8, -1) !== 'Object') {
        return console.error('参数传递错误')
    }
    if (!instance) {
        instance = new PreviewImageConstructor({
            data: options
        })
    } else {
        let { images=[], startPosition=0,upLoadMsg={} } = options;
        instance.images = images;
        instance.startPosition = startPosition;
        instance.upLoadMsg = upLoadMsg;
        instance.$mount()
    }

    document.body.appendChild(instance.$mount().$el) //this.$el拿到组件实际上的dom，把他挂载到body上
    return instance;
}
export default PreviewImage;


// WEBPACK FOOTER //
// ./src/components/PreviewImage/index.js